'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'holly-berry';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7aa';
var svgPathData = 'M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32A64 64 0 1 1 192 64a64 64 0 1 1 128 0zM46.6 343.6L96 327.1l.8-45.7 .6-32.3 31.9 4.7 46.7 6.9 44.4-20.5L256 224l-7.1 38.5L240 310.6l18.3 43.7 5.1 12.1 5.1-12.1 18.3-43.7-8.9-48.1L270.7 224l35.6 16.4 44.4 20.5 46.7-6.9 31.9-4.7 .6 32.3 .8 45.7 49.4 16.5 30.6 10.2-14.1 29-19.6 40.3 9.9 49.7 7.8 39.2-36.1-17.3-45.7-21.9L369.2 482l-31.8 6.6-1.1-32.5-1.6-47.2-48.1-15.3-23.3-7.4-23.3 7.4L192 408.9l-1.6 47.2-1.1 32.5L157.5 482l-43.7-9.1L68.1 494.7 32 512l7.8-39.2 9.9-49.7L30.1 382.8 16 353.8l30.6-10.2zM128 327.7l-.4 22.6-21.5 7.2L60.8 372.6l17.8 36.5 4.7 9.7-2.1 10.6-5.2 26.1L100 444l9.7-4.7 10.6 2.2 38.3 8 1.4-41.7 .8-22.6 21.5-6.8L227.7 364l-17.2-41-3.7-8.8 1.7-9.4 4.8-25.9-24 11-8.7 4-9.4-1.4-42.6-6.3-.7 41.5zm270.7 0l-.7-41.5-42.6 6.3-9.4 1.4-8.7-4-24-11 4.8 25.9 1.7 9.4-3.7 8.8L299 364l45.3 14.4 21.5 6.8 .8 22.6 1.4 41.7 38.3-8 10.6-2.2 9.7 4.7 24.1 11.5-5.2-26.1-2.1-10.6 4.7-9.7 17.8-36.5-45.4-15.1-21.5-7.2-.4-22.6zM112 144c0-30.4 21.2-55.8 49.6-62.4c2 10.9 5.9 21.2 11.3 30.5C156.7 113.7 144 127.4 144 144c0 17.7 14.3 32 32 32c16.6 0 30.3-12.7 31.9-28.9c9.3 5.4 19.6 9.3 30.5 11.3c-6.5 28.4-32 49.6-62.4 49.6c-35.3 0-64-28.7-64-64zm224 64c-30.4 0-55.8-21.2-62.4-49.6c10.9-2 21.2-5.9 30.5-11.3c1.5 16.2 15.2 28.9 31.9 28.9c17.7 0 32-14.3 32-32c0-16.6-12.7-30.3-28.9-31.9c5.4-9.3 9.3-19.6 11.3-30.5c28.4 6.5 49.6 32 49.6 62.4c0 35.3-28.7 64-64 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHollyBerry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;